import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    height: 100%;
    top: 50%;
    transform: translateY(-100%);
    width: 100;
`

class LoadingContainer extends Component {
    render() {
        return <Wrapper>Loading...</Wrapper>
    }
}

export default LoadingContainer
